import Axios from "axios";

class LogTransacaoDataService {
  getAll() {
    return Axios.get("logTransacoes");
  }

  getPage(params) {
    return Axios.get("logTransacoes/page", { params });
  }

  find(id) {
    return Axios.get(`logTransacoes/${id}`);
  }
}

export default new LogTransacaoDataService();
